export default __webpack_public_path__ + "static/media/Devices@2x.426e477d.png";